import styled from 'styled-components/macro'

import { Layout, Text } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { hasLaneDetails, type Lane } from '../domain/Lane'
import { getExtraFieldsFromPreference } from '../domain/LanePreferences'
import { type Mode } from '../domain/Mode'

export type RfpLaneDetailsProps = {
  lane: Lane
  preferenceMode: Mode
}

const Row = styled.div`
  padding-bottom: ${getToken('space-m')};
  padding-right: ${getToken('space-l')};
  padding-top: ${getToken('space-m')};
  border-bottom: 1px solid ${getToken('color-neutral-light')};

  &:last-child {
    border-bottom: none;
  }
`

export function RfpLaneDetails({ lane, preferenceMode }: RfpLaneDetailsProps) {
  const preference = lane.preferences.find(preference => preference.mode === preferenceMode)

  const extraFields: Array<string> = getExtraFieldsFromPreference(preference)

  if (!hasLaneDetails(lane)) {
    return null
  }

  return (
    <Layout.Stack>
      {extraFields.map((key, index) => (
        <Row key={`${lane.id}-${index}`}>
          <Layout.Group space="m">
            <Text variant="body-bold">{key.toUpperCase()}</Text>
            <Text>{preference?.extraFields![key]}</Text>
          </Layout.Group>
        </Row>
      ))}
      {lane.notes && (
        <Row>
          <Layout.Group space="m">
            <Text variant="body-bold">NOTES</Text>
            <Text>{lane.notes}</Text>
          </Layout.Group>
        </Row>
      )}
    </Layout.Stack>
  )
}
